<!-- 选择课程 -->
<template>
  <el-form-item>
    <template #label>
      <div class="el-form-item__label">
        <slot>
          {{ label }}
        </slot>
      </div>
    </template>
    <yx-course-selector @select="select" ref="child" @clear="clear" width="222px" />
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-课程选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '课程：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    function reset() {
      // eslint-disable-next-line no-use-before-define
      course.value = props.value;
      if (props.value.id) {
        child.value.setField(props.value.curriculumName);
      } else {
        child.value.clearField();
      }
    }

    const course = useQuery('curriculum', props.value, reset);
    onMounted(() => {
      if (props.value.id) {
        child.value.setField(props.value.curriculumName);
      } else {
        child.value.clearField();
      }
    });

    function select(obj) {
      course.value = obj;
    }

    return {
      reset,
      select,
      child,
      clear() {
        course.value = {};
        child.value.clearField();
      },
    };
  },
};
</script>
